export const Page = {
  TrainingMatrix: 1,
  GapAnalysis: 2
} as const
export type Page = (typeof Page)[keyof typeof Page]

export const XLG_DROPDOWN_DATA = [
  { id: Page.TrainingMatrix, text: 'Training Matrix' },
  { id: Page.GapAnalysis, text: 'Gap Analysis' }
]
